(function() {
    'use strict';

    angular
        .module('bhsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('bilan-national', {
            parent: 'entity',
            url: '/bilan-national?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'bhsApp.bilanNational.home.title'
            },
            views: {
                'content@bhs': {
                    templateUrl: 'app/entities/bilan-national/bilan-nationals.html',
                    controller: 'BilanNationalController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('bilanNational');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('bilan-national-detail', {
            parent: 'entity',
            url: '/bilan-national/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'bhsApp.bilanNational.detail.title'
            },
            views: {
                'content@bhs': {
                    templateUrl: 'app/entities/bilan-national/bilan-national-detail.html',
                    controller: 'BilanNationalDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('bilanNational');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'BilanNational', function($stateParams, BilanNational) {
                    return BilanNational.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'bilan-national',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('bilan-national-detail.edit', {
            parent: 'bilan-national-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/bilan-national/bilan-national-dialog.html',
                    controller: 'BilanNationalDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['BilanNational', function(BilanNational) {
                            return BilanNational.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('bilan-national.new', {
            parent: 'bilan-national',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/bilan-national/bilan-national-dialog.html',
                    controller: 'BilanNationalDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nomFichier: null,
                                fichierBilan: null,
                                fichierBilanContentType: null,
                                datePublication: null,
                                userPublication: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('bilan-national', null, { reload: 'bilan-national' });
                }, function() {
                    $state.go('bilan-national');
                });
            }]
        })
        .state('bilan-national.edit', {
            parent: 'bilan-national',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/bilan-national/bilan-national-dialog.html',
                    controller: 'BilanNationalDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['BilanNational', function(BilanNational) {
                            return BilanNational.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('bilan-national', null, { reload: 'bilan-national' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('bilan-national.delete', {
            parent: 'bilan-national',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/bilan-national/bilan-national-delete-dialog.html',
                    controller: 'BilanNationalDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['BilanNational', function(BilanNational) {
                            return BilanNational.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('bilan-national', null, { reload: 'bilan-national' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
